/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import { AvailabilityDelayEnum } from './availabilityDelayEnum';
import { NullEnum } from './nullEnum';

export type TrainingServiceProfileAvailabilityDelay =
  | (typeof TrainingServiceProfileAvailabilityDelay)[keyof typeof TrainingServiceProfileAvailabilityDelay]
  | null;

export const TrainingServiceProfileAvailabilityDelay = {
  ...AvailabilityDelayEnum,
  ...NullEnum,
} as const;
